import getConfig from 'next/config'

type PublicConfig = {
  bugsnagApi: string
  bookshelfUrl: string
  frontendServiceUrl: string
  statusPageApiUrl: string
  statusPageUrl: string
  existingSearchPage: string
  deepLinkPath: (action: string) => string
  qrPath: (link: string) => string
}

export function getPublicRuntimeConfig(): PublicConfig {
  const {
    publicRuntimeConfig: {
      bookshelfUrl,
      frontendServiceUrl,
      statusPageApiUrl,
      statusPageUrl,
      bugsnagApi,
      existingSearchPage,
      deeplinkPathPrefix,
      qrPathPrefix,
    },
  } = getConfig()

  return {
    bookshelfUrl,
    frontendServiceUrl,
    statusPageApiUrl,
    statusPageUrl,
    bugsnagApi,
    existingSearchPage,
    deepLinkPath: action => `${deeplinkPathPrefix}${action}`,
    qrPath: link => `${qrPathPrefix}${link}`,
  } as PublicConfig
}
